<template>
	<div class="modal fade" id="modal-notainterna">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">Gravação</h4>
					<button type="button" class="close" data-dismiss="modal">
						<img :src="logotipo" style="width: 30px; height: 35px; opacity: 1;">
						&times;
					</button>
				</div>

				<div class="modal-body">

					<div class="modal-body">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Unidades envolvidas</label>
									<select multiple readonly class="form-control form-control-sm" id="env_unidades" @dblclick="rmv_envolvido">
										<option v-for="opt in envolvidos.unidades" :value="opt" :key="opt">{{ opt }}</option>
									</select>
								</div>
								<div v-if="!block" class="input-group mb-3 input-group-sm">
									<input type="text" class="form-control" id="new_env_unidade" @keyup.enter="add_envolvido('unidade')">
									<div class="input-group-append">
										<button class="btn btn-primary" @click="add_envolvido('unidade')">add</button> 
									</div>
								</div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
									<label>{{view_nome.agente_envolvidos}}</label>
									<select multiple readonly class="form-control form-control-sm" id="env_pessoas" @dblclick="rmv_envolvido">
										<option v-for="opt in envolvidos.pessoas" :value="opt" :key="opt">{{ opt }}</option>
									</select>
								</div>
								<div v-if="!block" class="input-group mb-3 input-group-sm">
									<input type="text" class="form-control" id="new_env_pessoa" @keyup.enter="add_envolvido('pessoa')">
									<div class="input-group-append">
										<button class="btn btn-primary" @click="add_envolvido('pessoa')">add</button> 
									</div>
								</div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
									<label>Cargos</label>
									<select multiple readonly class="form-control form-control-sm" id="env_cargos" @dblclick="rmv_envolvido">
										<option v-for="opt in envolvidos.cargos" :value="opt" :key="opt">{{ opt }}</option>
									</select>
								</div>
								<div v-if="!block" class="input-group mb-3 input-group-sm">
									<input type="text" class="form-control" id="new_env_cargo" @keyup.enter="add_envolvido('cargo')">
									<div class="input-group-append">
										<button class="btn btn-primary" @click="add_envolvido('cargo')">add</button> 
									</div>
								</div>
							</div>
						</div>

						<div class="d-sm-flex justify-content-between mb-3">
							<div class="p-2 mr-1">
								<b>ID: </b> {{ gravacao.id }}
							</div>

							<div v-if="block" class="p-2 mr-1">
								<b>Usuário: </b> {{ ator.name }}
							</div>

							<div v-if="!block" class="p-2 mr-1">
								<b>Protocolo: </b> {{ gravacao.protocolo }}
							</div>

							<div v-if="!block" class="p-2 mr-1">
								<b>Origem: </b> {{ Phone(gravacao.origem) }}
							</div>

							<div class="p-2 mr-1">
								<b>Data: </b> {{ gravacao.created_at | moment("DD/MM/YYYY") }}
							</div>

							<div class="p-2 mr-1">
								<b>Hora: </b> {{ convert_hor(gravacao.created_at) | moment("HH:mm:ss") }}
							</div>
						</div>
					</div>

					<player v-if="!block" ref="wavesurfer" :audio_hash="audio_hash" />

					<div class="row">
						<div class="col-md-8">
							<div class="form-group">
								<label  for="resumo">Resumo</label>
								<small class="info link" data-toggle="popover" data-content="Descrição sucinta sobre o conteúdo do áudio.">
					        		<i class="fas fa-question-circle"></i>
					        	</small>

					        	<input type="text" id="resumo" class="form-control form-control-sm" v-model="estado.resumo" :readonly="block">
							</div>
						</div>

						<div class="col-md-4" v-if="view_nome.tipo_delito_lig == 1">
							<div class="form-group">
								<label  for="delito">{{view_nome.tipo_delito}}</label>
								<small class="info link" data-toggle="popover" data-content="Aponta, se houver, o {{view_nome.tipo_delito}} ocorrido nesta denúncia.">
					        		<i class="fas fa-question-circle"></i>
					        	</small>

					        	<input type="text" id="delito" class="form-control form-control-sm" v-model="estado.assunto" :readonly="block">
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label  for="prioridade">Prioridade</label>
								<select name="prioridade" id="prioridade" class="form-control form-control-sm" v-model="estado.prioridade" :readonly="block">
									<option value="1">Não visualizado</option>
									<option value="2">Irrelevante</option>
									<option value="3">Baixa</option>
									<option value="4">Média</option>
									<option value="5">Alta</option>
								</select>
							</div>
						</div>

						<div class="col-md-4">
							<div class="form-group">
								<label  for="unidade">Unidade</label>
								<select name="unidade" id="unidade" class="form-control form-control-sm" v-model="estado.unidade_id" :readonly="(block || !is_adm)">
									<option v-for="uni in unidades" :value="uni.id" :key="uni.id">{{ uni.nome }}</option>
								</select>
							</div>
						</div>

						<div class="col-md-4">
							<div class="form-group">
								<label  for="status">Status</label>
								<select v-if="estado.status" id="statusDn" class="form-control form-control-sm" v-model="estado.status.id" :readonly="block">
									<option v-for="den_status in denuncia_status" :value="den_status.id" :key="den_status.id">{{ den_status.nome }}</option>
								</select>
							</div>
						</div>
					</div>
					
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label  for="transcricao">Transcrição <font-awesome-icon icon="file-signature" class="pointer info ml-1" title="Transcrever automaticamente" @click="transcript" /></label>

								<transition mode="out-in" name="leftIn">
									<Loading  v-if="loading" />
									<textarea v-else class="form-control form-control-sm" name="transcricao" id="transcricao" cols="30" rows="8"  v-model="estado.transcricao" :readonly="block"></textarea>
								</transition>
							</div>
						</div>
					
						<div class="col-md-6">
							<div class="form-group">
								<label  for="analise">Análise</label>
								<textarea class="form-control form-control-sm" name="analise" id="analise" cols="30" rows="8"  v-model="estado.analise" :readonly="block"></textarea>
							</div>
						</div>
					</div>

				</div>


				<div v-if="!block" class="modal-footer">
					<div class="row">
						<div class="col-auto">
							<button class="btn btn-sm btn-light" @click="atualizar">Salvar</button>

							<router-link :to="{name: 'Gravacao', params: {get: 'Monitor', gravacao: gravacao.id, ramal: ramal} }" class="ml-1">
								<button class="btn btn-sm btn-light" data-dismiss="modal">Histórico</button>
							</router-link>

							<button class="btn btn-sm btn-light ml-1" data-dismiss="modal">Cancelar</button>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import api     from "@/mixins/api.js"
	import replace from "@/mixins/replace.js"
	import player  from "@/components/Tools/Player.vue"

	export default {
		name: "modal-notainterna",
		props: [ 'gravacao', 'block', 'ramal' ],
		mixins: [ api, replace ],
		components: { player },

		data: () => { return {
			incomplete: false,
			loading: false,
			audio_hash: null,
			ator: {},
			estado: {},
			unidades: {},
			envolvidos: { unidades: [], pessoas: [], cargos: [] },
		}},

		mounted() {
			this.load_unidades(),
			this.load_denuncia_status()
		},

		watch: {
			gravacao() { 
				this.envolvidos = { unidades: [], pessoas: [], cargos: [] }
				this.block ? this.load_activity() : this.load_data()
			}
		},

		computed: {
			logotipo() { return this.$store.state.config.logotipo },
			usuario()  { return this.$store.state.user },
			is_adm()   { return ( this.$store.state.user.type > 1 ) },
			view_nome(){ return this.$store.state.config_view_menu }
		},

		methods: {
			async load_unidades() {
				const response = await this.GET("Unidade")

				if ( response.status == "success" )
					this.unidades = response.result
			},

			async load_data() {
				const response = await this.GET("Gravacao/Historico", this.gravacao.last_action)

				if ( response.status == "success" ){
					this.estado = response.result
					this.estado.gravacao = this.gravacao.id
				}

				this.load_audio()
				this.load_envolvidos()
			},

			async load_audio() {
				const response = await this.GET("Gravacao", this.gravacao.id)
				this.audio_hash = (response.status = 'success') ? response.result.file : this.gravacao.file
			},

			async load_denuncia_status() {
				const response = await this.GET("Denuncia/DenunciaStatus")

				if ( response.status == "success" )
					this.denuncia_status = response.result
			},

			async load_activity() {
				this.estado = this.gravacao
				this.load_envolvidos()

				const response = await this.GET("User", this.estado.usuario_id)
				this.ator = (response.status == 'success') ? response.result : {}
			},

			async transcript() {
				this.loading = true
				const response = await this.POST("CPQD/ASR", { path: this.gravacao.path })
				this.estado.transcricao = response.text
				this.loading = false
			},

			load_envolvidos() {
				if ( this.estado.env_unidades ) 
					this.envolvidos.unidades = this.estado.env_unidades.split(',')

				if ( this.estado.env_pessoas ) 
					this.envolvidos.pessoas = this.estado.env_pessoas.split(',')

				if ( this.estado.env_cargos ) 
					this.envolvidos.cargos = this.estado.env_cargos.split(',')
			},

			async atualizar() {
				delete this.estado.id
				this.estado.usuario = this.usuario.id

				if ( this.envolvidos.unidades )
					this.estado.env_unidades = this.envolvidos.unidades.join(',')

				if ( this.envolvidos.pessoas )
					this.estado.env_pessoas = this.envolvidos.pessoas.join(',')

				if ( this.envolvidos.cargos )
					this.estado.env_cargos = this.envolvidos.cargos.join(',')


				const response = await this.POST("Gravacao/Historico", this.estado)

				if ( response.status == "success") this.$emit("alert", { status: "success", result: "Dados atualizados com sucesso."} )
				else window.alert(response.result)
			},

			add_envolvido(payload) {
	            let input    = ''
	            let array    = []
				const option = document.createElement('option')

				if ( payload == 'unidade' ) {
                	input  = document.getElementById("new_env_unidade")
                	array  = this.envolvidos.unidades
				}

				if ( payload == 'pessoa' ) {
                	input  = document.getElementById("new_env_pessoa")
                	array  = this.envolvidos.pessoas
				}

				if ( payload == 'cargo' ) {
                	input  = document.getElementById("new_env_cargo")
                	array  = this.envolvidos.cargos
				}

				if ( input.value ) {
					array.push(input.value)
					input.value = ''
				}
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			rmv_envolvido(e) {
				const option = e.target
				const select = option.parentNode
				let array = []

				if ( select.id == 'env_unidades' ) array = this.envolvidos.unidades
				if ( select.id == 'env_pessoas' )  array = this.envolvidos.pessoas
				if ( select.id == 'env_cargos' )   array = this.envolvidos.cargos

				array.splice( array.indexOf(option.value), 1 )
			}
		}
	}
</script>

<style scoped>
</style>
